import { InquiriesResponse } from '../models/inquiriesModel'
import { API } from './apiClient'

const BASE_URL = '/mi/contracts'

export const getInquiries = (contractId: string, idToken: string): Promise<InquiriesResponse> => {
  return API.get(`${BASE_URL}/${contractId}/inquiries`, {
    headers: { Authorization: idToken },
  })
}
